module.exports = __webpack_public_path__ + "b4a1f2ec.svg";